'use strict';

/**
 * Tenants controller
 */
(function () {
  angular
    .module('specsguardApp')
    .controller('TenantsCtrl', TenantsCtrl);

  TenantsCtrl.$inject = ['Auth', 'users', 'tenants', 'Constants', '$mdDialog', 'errorMessageService', 'Labels'];

  function TenantsCtrl (Auth, users, tenants, Constants, $mdDialog, errorMessageService, Labels) {

    const vm = this;

    vm.LABELS = Labels;
    vm.tenants = tenants;
    vm.users = users;

    vm.$onInit = () => {
      vm.update();
    };

    vm.update = (tenantsArr = vm.tenants, usersArr = vm.users) => {
      addUsersToTenants(tenantsArr, usersArr);
      vm.tenants = tenantsArr;
      setTenantLogos();
      return vm.tenants;
    };

    vm.updateTenant = (updatedTenant, usersArr) => {
      const tenantIdx = vm.tenants.findIndex((t) => t._id === updatedTenant._id);
      if (tenantIdx > -1) {
        vm.tenants = [...vm.tenants.slice(0, tenantIdx), updatedTenant, ...vm.tenants.slice(tenantIdx + 1)];
      } else {
        vm.tenants = [...vm.tenants, updatedTenant];
      }

      vm.update(vm.tenants, usersArr);

      return tenantIdx > -1 ? vm.tenants[tenantIdx] : updatedTenant;
    };

    /**
     * addUsersToTenant
     * This function is used to make sure that a tenant shows the corresponding user
     *
     * @param {Array} tenantsArr should contain the tenants object
     * @param {Array} usersArr Users
     *
     */
    const addUsersToTenants = (tenantsArr, usersArr) => {
      tenantsArr.forEach((tenant) => {
        tenant.users = usersArr.filter((user) => {
          if (angular.isDefined(user.databases) && angular.isArray(user.databases)) {
            return user.databases.includes(tenant.name);
          }
        });
      });
    };

    /**
     * OpenPanel
     * Function is used to decide which dialog you're showing
     * (Edit a tenant, create new tenant, Copy tenant)
     *
     * @param {Object} ev - sets events object
     * @param {Object} selectedTenant - get tenant/user data
     * @param {String} dialogType - enum: ['new', 'edit', 'copy', 'delete']
     */
    vm.openPanel = (ev, selectedTenant, dialogType) => {
      const tenant = selectedTenant;

      $mdDialog.show({
        clickOutsideToClose: true,
        controller: 'TenantDetailsCtrl',
        controllerAs: 'TenantDetailsController',
        preserveScope: false,
        multiple: true,
        locals: {
          tenant: tenant ? tenant : {},
          update: vm.updateTenant,
          users,
          dialogType
        },
        templateUrl: 'app-legacy/tenants/details/tenants-detail-dialog.tmpl.html',
        targetEvent: ev
      })
        .then(() => {
        })
        .catch(() => {});

    };

    function openTenantDetail (index, id) {
      const tenant = vm.tenants.find((t) => t._id === id);
      vm.openPanel(null, tenant, 'detail');
    }

    function setTenantLogos () {
      vm.tenants.forEach((t) => {
        t.images = t.uploads.filter((upload) => upload.file.type.includes('image/'));
        if (t.images.length === 0) {
          t.images.push({
            path: '/static/images/menu_logo.png',
            file: {
              type: 'image/png'
            }
          });
        }
      });
    }

    /**
     * tableColumns object is used to set the dynamic filter table
     */
    vm.tableColumns = [{
      thClass: 'sg-mat-table-cell-logo',
      tdClass: 'sg-mat-table-cell-logo',
      headerTitle: vm.LABELS.getLabel('logo'),
      template: 'app-legacy/tenants/tenants-table-templates/tenant.logo.template.html',
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getLabel('tenantsname'),
      type: 'string',
      sortable: true,
      filterData: vm.tenants,
      displayKey: 'name',
      thClass: 'sg-mat-table-cell--user',
      columnClickHandler: openTenantDetail,
      columnFilter: true,
    }, {
      headerTitle: vm.LABELS.getPlural('option'), // need this to fill out the columnFilter directive
      tdClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
      thClass: 'sg-mat-table__cell--options sg-mat-table__cell--align-right',
      template: 'app-legacy/tenants/tenants-table-templates/tenant.options.template.html',
      columnClickHandler: openTenantDetail,
      columnFilter: true,
    }];

    vm.columnFilters = {
      enabled: false,
    };

  }

})();
